import type { Badge } from "@/hooks/useMotivation";

interface Props {
  badges: Badge[];
  loading: boolean;
}

export default function BadgeGrid({ badges, loading }: Props) {
  if (loading) {
    return (
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="font-heading font-semibold text-base text-foreground-950">Rozetler</h3>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="h-28 rounded-md bg-background-100 animate-pulse" />
          ))}
        </div>
      </div>
    );
  }

  const earnedCount = badges.filter((b) => b.earned).length;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold text-base text-foreground-950">Rozetler</h3>
        <span className="text-xs text-foreground-500">
          {earnedCount} / {badges.length} kazanıldı
        </span>
      </div>

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {badges.map((b) => (
          <div
            key={b.id}
            className={`rounded-md border p-4 flex flex-col ${
              b.earned
                ? "border-primary-200 bg-primary-50"
                : "border-background-200 bg-background-50 opacity-70"
            }`}
          >
            <span
              className={`w-11 h-11 flex items-center justify-center rounded-full ${
                b.earned
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-400"
              }`}
            >
              <i className={`${b.icon} text-xl`} aria-hidden="true"></i>
            </span>
            <p className="mt-3 text-sm font-semibold text-foreground-950">{b.label}</p>
            <p className="mt-0.5 text-xs text-foreground-600 leading-snug">{b.description}</p>
            <div className="mt-3 h-1.5 w-full rounded-full bg-background-200 overflow-hidden">
              <div
                className={`h-full rounded-full ${b.earned ? "bg-primary-500" : "bg-background-300"}`}
                style={{ width: `${b.progress}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}